<template>
  <div v-cloak>
    <div>
      <b-container v-show="(!isBusy && !errored)" fluid>
        <b-row>
          <b-col sm="10" class="my-1 col-centered">
            <div v-if="hasProjects">
              <b-form-group label-cols-sm="2" label="Search" class="mb-0" v-show="dataRows>perPage">
                <b-input-group>
                  <b-form-input v-model="filter" placeholder="Type to Search"></b-form-input>
                  <b-input-group-append>
                    <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
                  </b-input-group-append>
                </b-input-group>
              </b-form-group>
              
            </div>

            <div v-else>
              <b-alert show variant="info">No assigned projects were found for this user.</b-alert>
            </div>
          </b-col>
        </b-row>
      </b-container>

      <div id="projectstable">
        <b-table
          selectable
          select-mode="single"
          striped
          outlined
          head-variant="light"
          :per-page="perPage"
          :current-page="currentPage"
          :filter="filter"
          :busy="isBusy"
          :items="projects"
          :fields="fields"
          @filtered="onFiltered"
          @row-selected="rowSelected"
        >

          <template v-slot:cell(projectId)="data">
          <span v-if="data.item.isActive">   {{ data.value }}   </span>
          <span v-if="!data.item.isActive"> <i> *{{ data.value }} </i>  </span>
          </template> 

          <template v-slot:cell(description)="data">
          <span v-if="data.item.isActive">   {{ data.value }}   </span>
          <span v-if="!data.item.isActive"> <i> {{ data.value }} </i>  <span class="text-danger font-weight-lighter">  [Inactive] </span> </span>
          </template>         

          <div slot="table-busy" class="text-center my-2">
            <b-spinner></b-spinner>
            <div>
              <strong>Loading...</strong>
            </div>
          </div>
        </b-table>
      </div>
      
    </div>

    <b-form-checkbox
    v-if="state.isSysAdmin"
    v-show="totalRows>0"
    class="ml-4 mb-2 bg-light"
    size="sm"
    :checked="showInactive"
    v-on:change="setShowActive($event)"
    
    >
    <i>Show Inactive </i>
  </b-form-checkbox>

    <b-pagination
      v-show="totalRows>perPage"
      v-model="currentPage"
      align="center"
      :total-rows="totalRows"
      :per-page="perPage"
      aria-controls="projectstable"
      hide-ellipsis
    ></b-pagination>

  <div class="text-center">
      <div v-if="errored">
        <b-alert show variant="danger">An error occurred loading the data.</b-alert>
        <p>{{ error }}</p>
        <b-button type="button" @click="reload">Retry</b-button>
      </div>
  </div>  

  </div>
  
</template>

<script>
export default {
  name: "SelectProject",
  props: {},
  components: {},

  data: function() {
    return {
      state: this.$store.state,
      perPage: 8,
      currentPage: 1,
      totalRows: 0,
      filter: null,
      selected: [],
      selectedId: 0,
      isBusy: true,
      data: null,
      projects: [],
      dataRows: 0,
      loading: true,
      loaded: false,
      errored: false,
      error: "",
      hasProjects: true,
      showInactive: false,

      fields: [
        {
          key: "projectId",
          sortable: true,
          label: "Project"
        },
        {
          key: "description",
          sortable: true
        },
        {
          key: "branchId",
          sortable: true,
          label: "Branch"
        }
      ]
    };
  },

  computed: {

  },

  methods: {
    reload() {
      this.errored = false;
      this.isBusy = true;
      this.fetchData();
    },
    rowSelected(items) {
      this.selected = items;
      if (items.length > 0) {
        this.$bvModal.hide("modal-select-project");
        this.selectedId = this.selected[0].projectId;
        if (this.selectedId != this.$router.currentRoute.params.id){
          this.$router.push({ name: "Project", params: { id: this.selectedId }  });
        };
      } else {
        this.selectedId = 0;
      }
    },

    fetchData() {
      this.$auth.acquireToken().then(token => {
        this.$http
          .get("api/UserProjects", {
            headers: { Authorization: "Bearer " + token }
          })
          .then(response => {
            this.data = response.data;
            this.projects = this.data.filter(o => o.isActive); 
            this.totalRows = this.projects.length;
            this.dataRows = this.projects.length;
            this.hasProjects = this.projects.length > 0;
            this.loaded = true;
          })
          .catch(error => {
            this.errored = true;
            this.loaded = false;
            this.error = error.response.statusText;
          })
          .finally(() => (this.isBusy = false));
      });
    },

  setShowActive(show){
      if (show){
        this.projects = this.data; 
        this.totalRows = this.projects.length;
      }
      else{
        this.projects = this.data.filter(o => o.isActive); 
        this.totalRows = this.projects.length;
      }
  },

    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    }
  },

  created: function() {
    this.fetchData();
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
#projectstable {
  text-align: left;
  max-width: 500px;
  margin: 0 auto;
  padding-top: 10px;
}

.col-centered {
  float: none;
  margin: 0 auto;
}

.pagination > li > a,
.pagination > li > span {
  color: darkred;
}

button.page-link {
    color: darkred;
    
}

.page-item.active .page-link {
   color:darkred;
   background-color: gainsboro;
   border-color: silver;
}

</style>